import lodash from 'lodash'
import * as tenanciesApi from '@/api/tenancies/request'
import types from '@/store/mutation-types'

const defaultState = {
  lastSearchedAttributes: {},
  allTenancyRecords: [],
}

const getters = {
  lastSearchedAttributes: state => state.lastSearchedAttributes,
  allTenancyRecords: state => state.allTenancyRecords,
}

// actions
const actions = {
  /** View-all list screens keep API rows in component `data` (cf. Project ViewAll); vuex stays for `lastSearchedAttributes`. */
  async loadAllTenancies ({ commit }, payload = {}) {
    const { query, diskCacheKey = null, isSilentGet = false, isViewAll } = payload
    const tenancies = await tenanciesApi.getAllTenancies(query, { isSilentGet, diskCacheKey })
    if (isViewAll === false || (query && query.isViewAll === false)) {
      commit(types.TENANCY_LOAD_ALL, { tenancies })
    }
    return tenancies
  },
  setLastSearchedAttributes ({ commit }, lastSearchedAttributes) {
    const attributes = lodash.cloneDeep(lastSearchedAttributes)
    commit(types.SET_LAST_SEARCH_ATTRIBUTES, { lastSearchedAttributes: attributes })
  },
}

// mutations
const mutations = {
  [types.TENANCY_LOAD_ALL] (state, { tenancies }) {
    state.allTenancyRecords = tenancies
  },
  [types.SET_LAST_SEARCH_ATTRIBUTES] (state, {lastSearchedAttributes}) {
    state.lastSearchedAttributes = lastSearchedAttributes
  },
  [types.RESET_STATE] (state) {
    state.lastSearchedAttributes = {}
    state.allTenancyRecords = []
  },
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
}
